class FeaturedBlogSwiperElement extends HTMLElement {
  connectedCallback() {
    this.swiperContainer = this.querySelector('.swiper');
    this.swiper = null;
    this.init();
  }

  init() {
    if (this.swiperContainer) {
      this.createSwiper();
    }
  }

  createSwiper() {
    const prevBtn = this.querySelector('.swiper-button-prev');
    const nextBtn = this.querySelector('.swiper-button-next');
    const scrollbar = this.querySelector('.swiper-scrollbar');

    this.nextButton = nextBtn;
    this.prevButton = prevBtn;
    this.scrollbar = scrollbar;

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      freeMode: false,
      watchOverflow: true,
      centeredSlides: false,
      allowTouchMove: true,
      preventClicks: false,
      preventClicksPropagation: false,
      breakpoints: {
        320: {
          slidesPerView: 1.1,
          spaceBetween: 16,
        },
        480: {
          slidesPerView: 1.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.1,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 24,
        }
      },
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      scrollbar: {
        el: this.scrollbar,
        draggable: true,
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

customElements.define('featured-blog-swiper', FeaturedBlogSwiperElement);